import dayjs from 'dayjs';
import { dateformat, diasDeSemanaUtil } from '../../../helpers';

export const notasByBloque = (
  planesEvaluacion,
  idMateria,
  idBloque,
  notasEvaluativas,
  actividadesExtras,
) => {
  const { total, count } = planesEvaluacion.reduce(
    (acc, { fechaBloque, materia, temas }) => {
      if (
        fechaBloque.bloquePedagogico.id === idBloque &&
        materia.id === idMateria
      ) {
        const { totalTema, countTema } = temas.reduce(
          (accTema, { evaluaciones }) => {
            const { totalEval, countEval } = evaluaciones.reduce(
              (accEval, { instrumentos }) => {
                const { totalInst, countInst } = instrumentos.reduce(
                  (accInst, { id }) => {
                    let notaEvaluativa = null;
                    if (notasEvaluativas) {
                      notaEvaluativa = notasEvaluativas.find(
                        (el) => el.ptevaInstrumento.id === id,
                      );
                    }

                    // let recuperacion = null;
                    // if (actividadesExtras) {
                    //   recuperacion = actividadesExtras.find(
                    //     (el) =>
                    //       el.actividadExtra.ptevaInstrumento?.id === id &&
                    //       el.actividadExtra.tipo === 'RECUPERACION',
                    //   );
                    // }

                    const notaValue = parseInt(notaEvaluativa?.nota ?? '0');

                    return {
                      totalInst: accInst.totalInst + notaValue,
                      countInst: accInst.countInst + (notaEvaluativa ? 1 : 0),
                    };
                  },
                  { totalInst: 0, countInst: 0 },
                );
                return {
                  totalEval: accEval.totalEval + totalInst,
                  countEval: accEval.countEval + countInst,
                };
              },
              { totalEval: 0, countEval: 0 },
            );
            return {
              totalTema: accTema.totalTema + totalEval,
              countTema: accTema.countTema + countEval,
            };
          },
          { totalTema: 0, countTema: 0 },
        );
        return {
          total: acc.total + totalTema,
          count: acc.count + countTema,
        };
      }
      return acc;
    },
    { total: 0, count: 0 },
  );

  return total > 0 ? Math.round(total / count) : 0;
};

export const asistenciasByHorarios = (
  bloques,
  planes,
  horarios,
  asistencias,
) => {
  let materias = [];
  planes.forEach((plan) => {
    const existe = materias.some((el) => el.id === plan.materia.id);
    if (!existe) materias.push(plan.materia);
  });

  let res = [];
  materias.forEach((materia) => {
    let asisGeneral = 0;
    let inasGeneral = 0;
    let bloquesArrary = [];
    bloques.forEach((bloque) => {
      const fechaDesde = bloque.fechaActiva.desde;
      const fechaHasta = bloque.fechaActiva.hasta;

      const horariosArray = horarios.filter(
        (el) => el.materia.id === materia.id,
      );
      let asisCount = 0;
      let inasCount = 0;

      horariosArray.forEach((horario) => {
        const dd = diasDeSemanaUtil.find((ds) => ds.dia === horario.dia);
        const dias = diasContinuoClases(dd.id, fechaDesde, fechaHasta);

        const asistenciasArray = asistencias.filter(
          (asistencia) => asistencia.horario.id === horario.id,
        );

        dias.forEach((dia) => {
          const asistencia = asistenciasArray.find((el) => {
            const hIni = dateformat(
              `${dateformat(dia, {})} ${horario.horaInicio}`,
              { format: 'YYYY-MM-DD HH:mm' },
            );
            const hFin = dateformat(
              `${dateformat(dia, {})} ${horario.horaFinal}`,
              {
                format: 'YYYY-MM-DD HH:mm',
              },
            );
            const fasi = dateformat(el.fechaHora, {
              format: 'YYYY-MM-DD HH:mm',
            });
            const existe = fasi >= hIni && fasi <= hFin;
            return existe;
          });

          if (asistencia) asisCount++;
          else inasCount++;
        });
      });

      asisGeneral = asisGeneral + asisCount;
      inasGeneral = inasGeneral + inasCount;

      bloquesArrary.push({
        id: bloque.id,
        nombre: bloque.nombre,
        asistencias: asisCount,
        inasistencias: inasCount,
      });
    });

    res.push({
      id: materia.id,
      nombre: materia.nombre,
      bloques: bloquesArrary,
      asisGeneral,
      inasGeneral,
    });
  });

  return res;
};

export const diasContinuoClases = (numDia, fechaInicio, fechaFinal) => {
  let array = [];
  let currentDate = dayjs(fechaInicio);
  while (!currentDate.isAfter(fechaFinal, 'day')) {
    if (currentDate.day() === numDia) {
      array.push(currentDate.toDate()); // Convert Day.js object to a Date object
    }
    currentDate = currentDate.add(1, 'day');
  }
  return array;
};

export const notasByBloquesPedagogicos = (
  bloquesPedagogicos,
  planesEvaluacion,
  notasEvaluativas,
  actividadesExtras,
) => {
  const getActividades = (idMateria, idBloque) =>
    planesEvaluacion.reduce((res, { fechaBloque, materia, temas }) => {
      if (
        fechaBloque.bloquePedagogico.id === idBloque &&
        materia.id === idMateria
      ) {
        temas.forEach(({ evaluaciones }) => {
          evaluaciones.forEach(({ instrumentos }) => {
            instrumentos.forEach(({ id, instrumento }) => {
              let actividad = null;
              if (notasEvaluativas) {
                actividad = notasEvaluativas.find(
                  (nota) => nota.ptevaInstrumento.id === id,
                );
              }

              // let recuperacion = null;
              // if (actividadesExtras) {
              //   actividadesExtras.find(
              //     (el) =>
              //       el.actividadExtra.ptevaInstrumento?.id === id &&
              //       el.actividadExtra.tipo === 'RECUPERACION',
              //   );
              // }

              res.push({
                nombre: instrumento.nombre,
                nota: actividad ? parseInt(actividad.nota) : 0,
              });
            });
          });
        });
      }
      return res;
    }, []);

  let materias = [];
  planesEvaluacion.forEach((plan) => {
    const existe = materias.some((el) => el.id === plan.materia.id);
    if (!existe) {
      materias.push({
        ...plan.materia,
        definitiva: 0,
      });
    }
  });

  let lista = [];
  materias.forEach((materia) => {
    let bloques = [];
    let promedio = 0;
    bloquesPedagogicos.forEach((bloque) => {
      const res = notasByBloque(
        planesEvaluacion,
        materia.id,
        bloque.id,
        notasEvaluativas,
        actividadesExtras,
      );

      const actividades = getActividades(materia.id, bloque.id);
      const planEvluacion = planesEvaluacion.find(
        (el) => el.fechaBloque.bloquePedagogico.id === bloque.id,
      );

      bloques.push({
        id: bloque.id,
        nombre: bloque.nombre,
        idPlanEvaluacion: planEvluacion.id,
        nota: res,
        actividades,
      });
    });

    bloques.forEach((el) => (promedio = promedio + el.nota));

    lista.push({
      ...materia,
      bloques,
      definitiva: Math.round(promedio / bloquesPedagogicos.length),
    });
  });

  console.log('notasByBloquesPedagogicos', lista);
  return lista;
};
